module.exports = __webpack_public_path__ + "img/icon-item-pre-rolled.842b67cb.svg";